export const SUPPORT_PHONE = "+387600000000";
export const SUPPORT_EMAIL = "support@rentpilot.ba";

export const getSupportPhoneHref = () => {
  return `tel:${SUPPORT_PHONE}`;
};

export const getSupportEmailHref = () => {
  return `mailto:${SUPPORT_EMAIL}?subject=RentPilot Support Request`;
};
